var __webpack_error__ = new Error();
module.exports = new Promise((resolve, reject) => {
	if(typeof mf_component !== "undefined") return resolve();
	__webpack_require__.l("https://lemoncare.lemonhc.com/ui/insu/resources/micro-frontend/component/dist/mf_component.js?v=d9774a51-66e4-4c40", (event) => {
		if(typeof mf_component !== "undefined") return resolve();
		var errorType = event && (event.type === 'load' ? 'missing' : event.type);
		var realSrc = event && event.target && event.target.src;
		__webpack_error__.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		__webpack_error__.name = 'ScriptExternalLoadError';
		__webpack_error__.type = errorType;
		__webpack_error__.request = realSrc;
		reject(__webpack_error__);
	}, "mf_component");
}).then(() => (mf_component));